/* @ngInject */
function AssetPreviewTabResultsPostsController ($scope, $translate, $rootScope, AssetPreviewService, Utils, ToastService, PostsService) {
  $scope.cards = []
  $scope.loading = true
  $scope.exportDisabled = false
  $scope.sincePublication = null
  const postId = $scope.contextData.postId

  const api = {
    _getAssetResults,
    _handleExportError,
    _getSincePublicationText,
    _handleSuccessGetLog,
    _generateResults
  }
  this.getApi = () => api

  $scope.$watchCollection('template', () => {
    $scope.loading = true
    $scope.cards = []

    $scope.templateDetails = $scope.template
    $scope.sincePublication = api._getSincePublicationText($scope.templateDetails)
    api._getAssetResults()
  })

  function _getSincePublicationText (details) {
    const locale = $rootScope.oUser.locale
    const dateObject = new Date(details.createdAt)
    const date = Intl.DateTimeFormat(locale).format(dateObject)

    return $translate.instant('sincePublish', { date })
  }

  $scope.exportAssetResults = () => {
    const { id, createdAt, isCustomizable } = $scope.templateDetails
    const endDate = new Date().toISOString()
    $scope.exportDisabled = true

    AssetPreviewService.exportAssetInsights($scope.assetSlug, isCustomizable, id, createdAt, endDate).then(({ signedUrl }) => {
      Utils.downloadFile(signedUrl)
      $scope.exportDisabled = false
    }).catch(api._handleExportError)

    ToastService.showSuccessToast($translate.instant('afterDownloadParagraph'))
  }

  function _handleExportError () {
    ToastService.showErrorToast($translate.instant('somethingWentWrongTryAgainMsg'))
  }

  function _getAssetResults () {
    const { assetId } = $scope.templateDetails

    PostsService.getAttachmentLog(assetId, postId)
      .then(api._handleSuccessGetLog)
  }

  function _handleSuccessGetLog (response) {
    const uniqueIndex = 'user_id'
    const groupedItems = Utils.groupBy(response, uniqueIndex)
    const data = groupedItems.map(userArr => {
      if (userArr.length >= 1 && userArr[0].type) {
        userArr[0].logs = userArr.map(user => {
          if (user.type === 'VIEW') {
            userArr[0].viewedAttachmentAt = user.createdAt
          }

          return {
            type: user.type,
            createdAt: user.createdAt
          }
        })
      }
      return userArr[0]
    })

    const key = 'role'
    $scope.dataLog = Utils.sortByKey(data.flat(), key)

    api._generateResults()
  }

  function _generateResults () {
    const getViewsProgress = (totalUsers, views) => Math.round((views / totalUsers) * 100) || 0
    const getDownloadsProgress = (totalUsers, downloads) => Math.round((downloads / totalUsers) * 100) || 0

    const totalUsers = $scope.dataLog.length
    const usersWhoViewed = $scope.dataLog.map(user => user.logs || []).flat().filter(logs => logs.type === 'VIEW').length
    const usersWhoDownloaded = $scope.dataLog.map(user => user.logs || []).flat().filter(logs => logs.type === 'DOWNLOAD').length

    const progressWhoViewed = `${getViewsProgress(totalUsers, usersWhoViewed)}%`
    const progressWhoDownloaded = `${getDownloadsProgress(totalUsers, usersWhoDownloaded)}%`

    $scope.cards.push(
      { name: 'dataFrames.preview.card.title.downloadedBy', result: { total: progressWhoDownloaded }, tooltip: 'dataFrames.preview.card.tooltips.downloadedBy' },
      { name: 'dataFrames.preview.card.title.viewedBy', result: { total: progressWhoViewed }, tooltip: 'dataFrames.preview.card.tooltips.viewedBy' }
    )

    $scope.loading = false
  }
}

export { AssetPreviewTabResultsPostsController }
